module.exports = __webpack_public_path__ + "media/replacement-of-olf-doors.459f149b.mp4";